import React from 'react'
import moment from 'moment'
import Card from 'transfix-ui/components/Card'
import FormattedPhoneNumber from 'transfix-ui/components/FormattedPhoneNumber'
import { Box, Typography } from 'transfix-ui/core'
import { IMotorCarrierInsuranceContact } from 'types/graphqlTypes'
import FORMATS from 'constants/datetime'
import { LoadableValue } from '../../../LoadableValue'
import { AgentInsuranceCertificationLink } from './AgentInsuranceCertificationLink'

interface IInsuranceAgentCard {
  agent: IMotorCarrierInsuranceContact
  loading?: boolean
}

export const InsuranceAgentCard = ({ agent, loading = false }: IInsuranceAgentCard) => {
  const { createdAt, email, fullName, insuranceDocuments, organizationName, phoneNumber } =
    agent || {}

  const formatedCreatedAtDate = moment(createdAt).format(FORMATS.dateFormat)
  return (
    <Box minWidth='330px' maxWidth='350px' mr='26px'>
      <Card>
        <Box minHeight='142px'>
          <Typography variant='subtitle1'>
            <LoadableValue value={fullName} loading={loading} />
          </Typography>
          <Typography variant='body1'>
            <LoadableValue value={organizationName} loading={loading} />
          </Typography>
          <Typography variant='body1'>
            <LoadableValue value={() => <FormattedPhoneNumber phoneNumber={phoneNumber} />} />
          </Typography>
          <Typography variant='body1'>
            <LoadableValue value={email} loading={loading} />
          </Typography>
          <Typography variant='body1'>
            {insuranceDocuments?.map(({ name, url }, i) => (
              <AgentInsuranceCertificationLink key={name} url={url} loading={loading} index={i} />
            ))}
          </Typography>
          <Typography variant='body1' color='textSecondary'>
            <LoadableValue value={formatedCreatedAtDate} loading={loading} />
          </Typography>
        </Box>
      </Card>
    </Box>
  )
}
